import { render, staticRenderFns } from "./cardVirtualConversations.vue?vue&type=template&id=47096544"
import script from "./cardVirtualConversations.vue?vue&type=script&lang=js"
export * from "./cardVirtualConversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports